import { render, staticRenderFns } from "./Empleado.vue?vue&type=template&id=41827a6f"
import script from "./Empleado.vue?vue&type=script&lang=js"
export * from "./Empleado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports